// @ts-nocheck
export const setup = () => {
  // NEW ANALYTICS
  ((i, s, o, g, r, a, m) => {
    i["GoogleAnalyticsObject"] = r;
    (i[r] =
      i[r] ||
      function (...args) {
        (i[r].q = i[r].q || []).push(args);
      }),
      (i[r].l = 1 * new Date());
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    "script",
    "https://www.googletagmanager.com/gtag/js?id=G-SZ1M22CFNJ",
    "ga"
  );
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(args);
  }
  gtag("js", new Date());
  gtag("config", "G-SZ1M22CFNJ");
};
